export enum TenantsEnum {
    FRHROM = 'frhrom',
    FRHPRJ = 'frhprj',
    FRHDEM = 'frhdem',
    FRHUZB = 'frhuzb',
    FRHPOL = 'frhpol',
    FRHPOR = 'frhpor',
}